import { createRequestHelper } from '@utils/swr'
import { type OrderItemsResponse } from '../types/apiResponse'
import { type ButlerApis } from '../types/apis'

const {
  useRequest,
  mutate,
} = createRequestHelper<ButlerApis['get']['orderItems'], OrderItemsResponse, string | null>({
  client: 'butler',
  key: orderId => orderId ? `/orders/${orderId}/order_items` : null,
})

export const useApiOrderItems = useRequest
export const mutateOrderItems = mutate
